import { usePermissions } from "components/util/helpers/providers/PermissionsProvider";

/** @module HasPermission **/

/**
 * Renders children when the current user has the requested permission
 * @param {Object} props Component props
 * @param {boolean} props.defaultValue Value used before permissions load or when permission is not defined
 * @param {React.ReactNode} props.children Content rendered when permission is granted
 * @param {React.ReactNode} props.fallback Content rendered when permission is denied
 * @param {string} props.permission Permission name
 * @param {number|string} props.resourceId Resource ID required for node and collection permissions
 * @returns {React.ReactNode|undefined} Children, fallback, or nothing
 * @example
 * <HasPermission
 *   permission={PERMISSIONS.NODE_EXECUTE}
 *   resourceId={node.id}
 *   fallback={null}
 * >
 *   <NodeView />
 * </HasPermission>
 */
export const HasPermission = ({ permission, resourceId, defaultValue, fallback, children }) => {

  const { hasPermission } = usePermissions();
  const fullfillPermision = hasPermission(permission, resourceId, defaultValue);

  if (fullfillPermision)
    return children;

  if (fallback)
    return fallback;

}
